export default "__VITE_ASSET__2807e645__"